import { ReportProgressStage } from "../Enums/ReportProgressStage";

export interface IReportProgress {
    progress: ReportProgressStage;
    verbiage: JSX.Element;
    stageName?: string;
}

export class ReportProgress implements IReportProgress {
    /**
     *
     */
    constructor(progress: ReportProgressStage, verbiage: JSX.Element, stageName?: string) {
        this.progress = progress;
        this.verbiage = verbiage;
        this.stageName = stageName;
    }
    public progress: ReportProgressStage;
    public verbiage: JSX.Element;
    public stageName: string;
}